import { ComponentType } from "react";
import { PersonTypeFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/** Тип сотрудника — значение справочника. */
export function PersonType({
  data,
  whenEmpty,
}: {
  data?: Hidable<PersonTypeFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(person) => (
        <LocalizedName data={person.personType?.value} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
